// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ri-2";
export var chatLink = "_ri-0";
export var chatText = "_ri-1";